import { showToast, removeAccents } from '@/@core/utils/utils';

export default {
  name: 'FilterCheckboxMultiLevel',
  components: {},
  props: {
    value: {
      type: Array,
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
    menus: {
      type: Array,
      required: true,
    },
    columns: {
      type: Number,
      required: false,
      default: 1,
    },
    placeholder: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    variant: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      open: false,
      selectedItem: this.value,
      showSelectedItem: true,
      keyword: '',
      activeMenu: 0,
      filteredItems: [],
    };
  },
  created() {
    this.setVariant();
    var father = JSON.parse(JSON.stringify(
        this.options.filter((x, index) => this.activeMenu == (index))[0]
    ));
    this.filteredItems = father;
  },
  watch: {},
  computed: {
    listItem() {
      return this.filteredItems;
    },
    listMenu() {
      return this.menus;
    }
  },
  methods: {
    clickOutSide() {
      this.open = false;
    },
    updateValue() {
      this.$emit('input', this.selectedItem);
    },
    onClickPicker() {
      this.open = !this.open;
    },
    setVariant() {
      if(this.variant === 'config') {
        this.showSelectedItem = false;
      } else {
        this.showSelectedItem = true
      }
    },
    searchAction() {
      var menuFather = JSON.parse(JSON.stringify(
        this.options.filter((x, index) => this.activeMenu == (index))
      ));
      
      menuFather[0].forEach((element,index) => {
      this.filteredItems[index].childs = menuFather[0][index].childs.filter((x) => {
          return removeAccents(this.$t(x.text)).split(' ')
              .join('')
              .toUpperCase()
              .includes(
                removeAccents(this.keyword).split(' ').join('').toUpperCase()
              )
          })
      });

      this.$forceUpdate();
    },
    changeMenu(index) {
      this.activeMenu = index;
      var father = JSON.parse(JSON.stringify(
        this.options.filter((x, index) => this.activeMenu == (index))[0]
      ));
      this.filteredItems = father;
    },
    onParentCheckboxChange(valueP) {
      var positionparent = this.filteredItems.find((x) => x.value == valueP);
      
      if(!this.selectedItem.includes(valueP)) {
        positionparent.childs.forEach(x => {
          if (this.selectedItem.includes(x.value)) {
            this.selectedItem = this.selectedItem.filter(item => item !== x.value);
          }
        });
      }else{
        positionparent.childs.forEach(x => {
          if (!this.selectedItem.includes(x.value)) {
            this.selectedItem.push(x.value);
          }
        });
      }
    },
    isAllChildChecked(valueP) {
      var positionparent = this.filteredItems.find((x) => x.value == valueP);
      var check = true;
      positionparent.childs.forEach(x => {
        if (!this.selectedItem.includes(x.value)) {
          check = false;
        }
      });
      if(check) {
        this.selectedItem.push(valueP);
      }else{
        if (this.selectedItem.includes(valueP)) {
          this.selectedItem = this.selectedItem.filter(item => item !== valueP);
        }
      }
    },
    destroySelected() {
      this.filteredItems.forEach(x => {
        if (this.selectedItem.includes(x.value)) {
          this.selectedItem = this.selectedItem.filter(item => item !== x.value);
        }
        x.childs.forEach(y => {
          if (this.selectedItem.includes(y.value)) {
            this.selectedItem = this.selectedItem.filter(item => item !== y.value);
          }
        })
      })
    },
    selectAll() {
      this.filteredItems.forEach(x => {
        if (!this.selectedItem.includes(x.value)) {
          this.selectedItem.push(x.value);
        }
        x.childs.forEach(y => {
          if (!this.selectedItem.includes(y.value)) {
            this.selectedItem.push(y.value);
          }
        })
      })
    }
  },
};
